"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Api_module_css_1 = __importDefault(require("./Api.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var CreateOAuth2ClientModal_1 = __importDefault(require("./CreateOAuth2ClientModal"));
var AccessControl_1 = __importDefault(require("@/Components/common/AccessControl"));
var react_admin_1 = require("react-admin");
var AjaxProvider_1 = __importDefault(require("../../functions/AjaxProvider"));
var OAuth2ClientList_1 = __importDefault(require("./OAuth2ClientList"));
var ReactAdminErrorBoundry_1 = __importDefault(require("../common/ReactAdmin/ReactAdminErrorBoundry"));
var OAuth2ClientComponent = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(false), isShown = _a[0], setIsShown = _a[1];
    var _b = (0, react_1.useState)("new"), modalMode = _b[0], setModalMode = _b[1];
    var _c = (0, react_1.useState)(null), currentOAuth2Token = _c[0], setCurrentOAuth2Token = _c[1];
    var openCreateO2AuthClientModal = function () {
        setModalMode("new");
        setCurrentOAuth2Token(null);
        setIsShown(true);
    };
    var handleRowClick = function (oAuthToken) {
        setModalMode("edit");
        setCurrentOAuth2Token(oAuthToken);
        setIsShown(true);
    };
    var closeModal = function () {
        setIsShown(false);
        setCurrentOAuth2Token(null);
    };
    return (react_1.default.createElement(react_admin_1.AdminContext, { dataProvider: (0, AjaxProvider_1.default)("/api") },
        react_1.default.createElement(ReactAdminErrorBoundry_1.default, { resourceName: "api", resourceURL: "/user/api-tokens" },
            react_1.default.createElement(react_admin_1.I18nContextProvider, { value: react_admin_1.defaultI18nProvider },
                react_1.default.createElement("div", { className: Api_module_css_1.default["content-container"] },
                    react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-end", style: { marginBottom: "5rem", marginRight: "4em" } },
                        react_1.default.createElement(AccessControl_1.default, { requiredPermissions: props.permissions.manage },
                            react_1.default.createElement(q_play_components_1.Button, { text: t("Create"), onClick: openCreateO2AuthClientModal, dataCy: "createO2AuthClientModalButton" }))),
                    react_1.default.createElement(OAuth2ClientList_1.default, { onRowClick: handleRowClick, permissions: props.permissions }),
                    react_1.default.createElement(CreateOAuth2ClientModal_1.default, { isShown: isShown, toggle: closeModal, mode: modalMode, oAuth2Token: currentOAuth2Token }))))));
};
exports.default = OAuth2ClientComponent;
